// src/components/DisableDraftMode.tsx

"use client";

import { useRouter } from "next/navigation";
import { useVisualEditingEnvironment } from "next-sanity/hooks";

export function DisableDraftMode() {
  const environment = useVisualEditingEnvironment();
  const router = useRouter();

  // Only show the disable draft mode button when outside of Presentation Tool
  if (environment === "presentation-iframe" || environment === "presentation-window") {
    return null;
  }

  const handleClick = async () => {
    await fetch("/api/draft-mode/disable");
    router.refresh();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="fixed bottom-4 text-black right-4 bg-gray-50 px-4 py-2 z-50"
    >
      Disable Draft Mode
    </button>
  );
}
